import { render } from "./BusinessUnitDetailsTable.vue?vue&type=template&id=2388f03a"
import script from "./BusinessUnitDetailsTable.vue?vue&type=script&lang=js"
export * from "./BusinessUnitDetailsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__